import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import sanitizeHtml from "sanitize-html";
import ReactHtmlParser from "react-html-parser";
import { htmlConvertToString } from "../../../constants/Validation";
import { useAuth } from "../../../authentication";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Col,
  Row,
  Card,
  Popover,
  message,
} from "antd";
import { AiOutlineUpload } from "react-icons/ai";
import { MinusCircleOutlined } from "@ant-design/icons";
import useDebounce from "../../../containers/Pages/Clients/ClientData/debounce";
import ClientsAPI from "../../../services/Clients/Clients";
import ColorPicker from "./ColorPicker";
// import moment from "moment";
import "./ClientForm.css";
import { ClientContextApi } from "../../../contextApi/ClientContext";
import UploadsAPI from "../../../services/Uploads/Uploads";
import LocationAPI from "../../../services/Location/Location";

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;
// const { RangePicker } = DatePicker;
const clientsApi = new ClientsAPI();
const LocationApi = new LocationAPI();
const UploadApi = new UploadsAPI();
// const dateFormat = 'MM/DD/YYYY';

const ClientForm = () => {
  const {
    editClientList,
    addNewClient,
    newClientCount,
    setNewClientCount,
    clientCount,
    updateClientCount,
  } = useContext(ClientContextApi);
  const history = useHistory();
  const { id } = useParams();
  const [form] = Form.useForm();
  const { authUser } = useAuth();

  let emailFieldTimeOut = 0;
  const regex = /(<([^>]+)>)/gi;
  const regex1 = /[\]}[{]/gi;

  const [searchCountry, setSearchCountry] = useState("");
  const [searchState, setSearchState] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedStateId, setSelectedStateId] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [isSubmitBtnLoading, setSubmitBtnLoading] = useState(false);
  // const [emailFieldTimeOut, setEmailFieldTimeOut] = useState(0);
  const [isEmailExist, setIsEmailExist] = useState({
    isEmailEnterd: false,
    isEmailExist: true,
  });
  const debouncedSearchCountry = useDebounce(searchCountry, 500);
  const debouncedSearchState = useDebounce(searchState, 500);
  const debouncedSearchCity = useDebounce(searchCity, 500);
  const [orgIdState, setOrgIdState] = useState({});
  const [bigLogoImage, setBigLogoImage] = useState([]);
  const [bigLogoImageURL, setBigLogoImageURL] = useState();
  const [smallLogoImage, setSmallLogoImage] = useState([]);
  const [smallLogoImageURL, setSmallLogoImageURL] = useState();
  const [faviconImage, setFaviconImage] = useState([]);
  const [faviconImageURL, setFaviconImageURL] = useState();
  const [colorState, setColorState] = useState({
    primaryHexColor: "",
    secondaryHexColor: "",
    layoutBackgroundColor: "",
  });
  const [clientProfile, setClientProfile] = useState([
    {
      // addressId: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      name: "",
      description: "",
      primaryHexColor: "",
      primaryFontDetails: "",
      secondaryHexColor: "",
      secondaryFontDetails: "",
      layoutBackgroundColor: "",
      logoBigUrl: "",
      logoSmallUrl: "",
      faviconUrl: "",
      effectiveStartDatetime: null,
      effectiveEndDatetime: null,
      createdDttm: null,
      updatedDttm: null,
    },
  ]);

  // Fetch client data
  const fetchData = async (id) => {
    if (id) {
      try {
        // Make an API call to fetch data by ID
        const response = await clientsApi.getClientInfo(id);
        const responseData = response.data;
        if (responseData) {
          // Set the form fields with the fetched data
          let clientName = ReactHtmlParser(responseData.client.name);
          let clientEmail = ReactHtmlParser(responseData.clientUser[0].email);
          form.setFieldsValue({
            name: clientName[0],
            email: clientEmail[0],
          });

          // Iterate through the clientProfile array to update corresponding fields
          for (
            let index = 0;
            index < responseData.clientProfile.length;
            index++
          ) {
            const profile = responseData.clientProfile[index];
            setBigLogoImageURL(profile.logoBigUrl);
            setSmallLogoImageURL(profile.logoSmallUrl);
            setFaviconImageURL(profile.faviconUrl);

            let clientBranchName = ReactHtmlParser(profile.name);
            let clientBranchWebsiteURL = ReactHtmlParser(profile.websiteUrl);
            let clientBranchDesc = ReactHtmlParser(profile.description);
            form.setFieldsValue({
              [`branchName${index}`]: clientBranchName[0],
              [`branchWebsiteURL${index}`]: clientBranchWebsiteURL[0],
              [`branchDescription${index}`]: clientBranchDesc[0],
              [`branchPrimaryFontDetails${index}`]: profile.primaryFontDetails,
              [`branchSecondaryFontDetails${index}`]:
                profile.secondaryFontDetails,
              [`primaryHexColor${index}`]: profile.primaryHexColor,
              [`secondaryHexColor${index}`]: profile.secondaryHexColor,
              [`layoutBackgroundColor${index}`]: profile.layoutBackgroundColor,
              [`branchLogoBigUrl${index}`]: profile.logoBigUrl || "",
              [`branchLogoSmallUrl${index}`]: profile.logoSmallUrl || "",
              [`branchFaviconUrl${index}`]: profile.faviconUrl || "",
              // [`branchDateRange${index}`]: [
              //   moment(new Date(profile.effectiveStartDatetime)),
              //   moment(new Date(profile.effectiveEndDatetime)),
              // ],
            });
            setOrgIdState({
              orgId: responseData.client.id,
              profileId: profile.id,
              locationId: profile.locationId,
              clientEmailId: responseData.clientUser[0].id,
              countryId:
                responseData.clientProfile[0].clientLocation[0]?.countryId,
              stateId: responseData.clientProfile[0].clientLocation[0]?.stateId,
              cityId: responseData.clientProfile[0].clientLocation[0]?.cityId,
            });
            setColorState({
              primaryHexColor: profile.primaryHexColor,
              secondaryHexColor: profile.secondaryHexColor,
              layoutBackgroundColor: profile.layoutBackgroundColor,
            });

            const locationId = profile.locationId;

            if (locationId) {
              try {
                const locationResponse = await LocationApi.getLocationById(locationId);
                const locationData = locationResponse.data;
                // Update the form fields with location data
                form.setFieldsValue({
                  [`branchAddress1${index}`]: locationData.address1,
                  [`branchAddress2${index}`]: locationData.address2,
                  [`branchCountryId${index}`]:
                    profile.clientLocation[0]?.countryName,
                  [`branchCityId${index}`]: profile.clientLocation[0]?.cityName,
                  [`branchStateId${index}`]:
                    profile.clientLocation[0]?.stateName,
                  [`branchZip${index}`]: locationData.zip,
                  // Other fields from the location data
                });
              } catch (locationError) {
                console.error("Error fetching location data:", locationError);
              }
            }
          }
        } else {
          message.error("Invalid client profile, Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    fetchData(id);
    //eslint-disable-next-line
  }, [id]);

  const removeClientProfile = (index) => {
    // Ensure there is more than one clientProfile object
    if (clientProfile.length > 1) {
      // Remove the last clientProfile object
      const updatedClientProfile = [...clientProfile];
      updatedClientProfile.splice(index, 1);
      setClientProfile(updatedClientProfile);

      // Reset the form fields
      form.resetFields();
      message.success("Client Profile removed successfully!");
    } else {
      form.resetFields();
      // message.warning("Cannot remove the last client profile.");
    }
  };

  // Get Country Name
  const handleSearchCountry = async (value) => {
    try {
      const response = await LocationApi.getSearchedCountry(value);
      const countriesData = response.data;
      setCountryOptions(countriesData);
      form.resetFields(["branchStateId0", "branchCityId0"]);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  // Get State name
  const handleSearchState = async (value) => {
    try {
      const countryId = selectedCountryId;
      const payloadCountryId = countryId ? countryId : orgIdState.countryId;
      const response = await LocationApi.getSearchedState(payloadCountryId, value);

      setStateOptions(response.data);
      form.resetFields(["branchCityId0"]);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  // Get City name
  const handleSearchCity = async (value) => {
    try {
      const countryId = selectedCountryId;
      const stateId = selectedStateId;
      const payloadCountryId = countryId ? countryId : orgIdState.countryId;
      const payloadStateId = stateId ? stateId : orgIdState.stateId;
      const response = await LocationApi.getSearchedCity(payloadCountryId, payloadStateId, value);
      setCityOptions(response.data);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  useEffect(() => {
      handleSearchCountry(debouncedSearchCountry);
    //eslint-disable-next-line
  }, [debouncedSearchCountry]);

  useEffect(() => {
    if(debouncedSearchState) {
      handleSearchState(debouncedSearchState);
    }
    //eslint-disable-next-line
  }, [debouncedSearchState]);

  useEffect(() => {
    if(debouncedSearchCity) {
      handleSearchCity(debouncedSearchCity);
    }
    //eslint-disable-next-line
  }, [debouncedSearchCity]);

  const handleChange = (index, name, value) => {
    const updatedClientProfile = [...clientProfile];
    if (name === "countryId") {
      setSelectedCountryId(value);
    }
    if (name === "stateId") {
      setSelectedStateId(value);
    }

    if (name === "primaryHexColor") {
      // Set the field value in the form
      form.setFieldsValue({ [`primaryHexColor${index}`]: value });
      // Check if the value is not empty, then remove the error message
      if (value) {
        form.setFields([
          {
            name: `primaryHexColor${index}`,
            errors: [],
          },
        ]);
      }
      let colorCode = colorState;
      colorCode.primaryHexColor = value;
      setColorState(colorCode);
    }
    if (name === "secondaryHexColor") {
      form.setFieldsValue({ [`secondaryHexColor${index}`]: value });
      if (value) {
        form.setFields([
          {
            name: `secondaryHexColor${index}`,
            errors: [],
          },
        ]);
      }
      let colorCode = colorState;
      colorCode.secondaryHexColor = value;
      setColorState(colorCode);
    }

    if (name === "layoutBackgroundColor") {
      form.setFieldsValue({ [`layoutBackgroundColor${index}`]: value });
      if (value) {
        form.setFields([
          {
            name: `layoutBackgroundColor${index}`,
            errors: [],
          },
        ]);
      }
      let colorCode = colorState;
      colorCode.layoutBackgroundColor = value;
      setColorState(colorCode);
    } else {
      if (
        name === "description" ||
        name === "name" ||
        name === "primaryFontDetails" ||
        name === "secondaryFontDetails"
      ) {
        value = htmlConvertToString(value);
      }
      updatedClientProfile[index][name] = value;
    }

    setClientProfile(updatedClientProfile);
  };

  // upload media files
  const uploadFiles = async (fileData) => {
    if (fileData.originFileObj) {
      try {
        const formData = new FormData();
        formData.append("asset-image", fileData.originFileObj);

        let payloadClientId = 0;
        if(authUser.clientId !== null) {
          payloadClientId = authUser.id;
        }
        const response = await UploadApi.uploadImages(formData, payloadClientId);

        if (response.data[0].Location) {
          return response.data[0].Location;
        } else {
          console.error('No "Location" found in the response.');
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    } else {
      return null;
    }
  };

  const handleCancel = () => {
    history.push("/clients/allClients");
  };

  // client add
  const clientAddFormSubmit = async (fieldValues) => {
    try {
      setSubmitBtnLoading(true);
      const bigLogoImagePath = await uploadFiles(bigLogoImage);
      const smallLogoImagePath = await uploadFiles(smallLogoImage);
      const faviconImagePath = await uploadFiles(faviconImage);

      if (
        bigLogoImagePath !== "" &&
        smallLogoImagePath !== "" &&
        faviconImagePath !== ""
      ) {
        let tempClientName = sanitizeHtml(fieldValues.name.trim())
          .replace(regex, "")
          .replace(regex1, "");
        let tempClientEmail = sanitizeHtml(fieldValues.email)
          .replace(regex, "")
          .replace(regex1, "");

        if (tempClientName === "" || tempClientEmail === "") {
          message.error(
            "Invalid data. Please put valid data in the form fields.",
          );
          setSubmitBtnLoading(false);
          return false;
        }

        // get client profile fields values
        let clientProfileData = [];
        for (let i = 0; i < clientProfile.length; i++) {
          let tempBranchAdd1 = sanitizeHtml(
            fieldValues["branchAddress1" + i].trim(),
          )
            .replace(regex, "")
            .replace(regex1, "");
          let tempBranchAdd2 = "";
          if (fieldValues["branchAddress2" + i]) {
            tempBranchAdd2 = sanitizeHtml(
              fieldValues["branchAddress2" + i].trim(),
            )
              .replace(regex, "")
              .replace(regex1, "");
          }
          let tempBranchZip = sanitizeHtml(fieldValues["branchZip" + i].trim())
            .replace(regex, "")
            .replace(regex1, "");
          let tempBranchName = sanitizeHtml(
            fieldValues["branchName" + i].trim(),
          )
            .replace(regex, "")
            .replace(regex1, "");
          let tempBranchDesc = sanitizeHtml(
            fieldValues["branchDescription" + i].trim(),
          )
            .replace(regex, "")
            .replace(regex1, "");
          let tempBranchWebsiteURL = sanitizeHtml(
            fieldValues["branchWebsiteURL" + i].trim(),
          )
            .replace(regex, "")
            .replace(regex1, "");

          if (
            tempBranchAdd1 === "" ||
            tempBranchZip === "" ||
            tempBranchName === "" ||
            tempBranchDesc === "" ||
            tempBranchWebsiteURL === ""
          ) {
            message.error(
              "Invalid data. Please put valid data in the form fields.",
            );
            setSubmitBtnLoading(false);
            return false;
          }

          const clientDataPayload = {
            address1: tempBranchAdd1,
            address2: tempBranchAdd2,
            countryId: fieldValues["branchCountryId" + i],
            cityId: fieldValues["branchCityId" + i],
            stateId: fieldValues["branchStateId" + i],
            zip: tempBranchZip,
            name: tempBranchName,
            description: tempBranchDesc,
            primaryHexColor: colorState.primaryHexColor,
            primaryFontDetails: fieldValues["branchPrimaryFontDetails" + i],
            secondaryHexColor: colorState.secondaryHexColor,
            secondaryFontDetails: fieldValues["branchSecondaryFontDetails" + i],
            layoutBackgroundColor: colorState.layoutBackgroundColor,
            logoBigUrl: bigLogoImagePath,
            logoSmallUrl: smallLogoImagePath,
            faviconUrl: faviconImagePath,
            // effectiveStartDatetime: fieldValues["branchDateRange" + index]
            //   ? moment(fieldValues["branchDateRange0"][0].format('YYYY-MM-DD')).valueOf()
            //   : null,
            // effectiveEndDatetime: fieldValues["branchDateRange" + index]
            //   ? moment(fieldValues["branchDateRange0"][1].format('YYYY-MM-DD')).valueOf()
            //   : null,
            createdDttm: new Date().getTime(),
            updatedDttm: new Date().getTime(),
            websiteUrl: tempBranchWebsiteURL,
          };
          clientProfileData.push(clientDataPayload);
        }

        const requestBody = {
          client: {
            name: tempClientName,
            createdDttm: new Date().getTime(),
            updatedDttm: new Date().getTime(),
          },
          clientUser: {
            email: tempClientEmail,
          },
          clientProfile: clientProfileData,
        };

        const response = await clientsApi.addClient(requestBody);

        if (response.data) {
          const index = 0;
          const addClient = {
            id: response.data.id,
            clientId: response.data.id,
            isDeleted: 0,
            clientName: tempClientName,
            name: sanitizeHtml(fieldValues["branchName" + index].trim())
              .replace(regex, "")
              .replace(regex1, ""),
            description: sanitizeHtml(
              fieldValues["branchDescription" + index].trim(),
            )
              .replace(regex, "")
              .replace(regex1, ""),
            primaryHexColor: colorState.primaryHexColor,
            primaryFontDetails: fieldValues["branchPrimaryFontDetails" + index],
            secondaryHexColor: colorState.secondaryHexColor,
            secondaryFontDetails:
              fieldValues["branchSecondaryFontDetails" + index],
            layoutBackgroundColor: colorState.layoutBackgroundColor,
            logoBigUrl: bigLogoImagePath,
            logoSmallUrl: smallLogoImagePath,
            faviconUrl: faviconImagePath,
            createdDttm: response.data.createdDttm,
            updatedDttm: response.data.updatedDttm,
          };

          await addNewClient(addClient);
          await setNewClientCount(newClientCount + 1);
          await updateClientCount(clientCount + 1);

          message.success("Client details has been added successfully.");
          history.push("/clients/allClients");
        }
      }
    } catch (error) {
      message.error(
        "Form submission failed. Please check the form for errors.",
      );
    } finally {
      setSubmitBtnLoading(false);
    }
  };

  // Client update
  const clientUpdateFormSubmit = async (fieldValues) => {
    try {
      setSubmitBtnLoading(true);
      const bigLogoImagePath = await uploadFiles(bigLogoImage);
      const smallLogoImagePath = await uploadFiles(smallLogoImage);
      const faviconImagePath = await uploadFiles(faviconImage);

      let tempClientName = sanitizeHtml(fieldValues.name.trim())
        .replace(regex, "")
        .replace(regex1, "");
      let tempClientEmail = sanitizeHtml(fieldValues.email)
        .replace(regex, "")
        .replace(regex1, "");

      if (tempClientName === "" || tempClientEmail === "") {
        message.error(
          "Invalid data. Please put valid data in the form fields.",
        );
        setSubmitBtnLoading(false);
        return false;
      }

      // get client profile fields values
      let clientProfileData = [];
      for (let i = 0; i < clientProfile.length; i++) {
        let tempBranchAdd1 = sanitizeHtml(
          fieldValues["branchAddress1" + i].trim(),
        )
          .replace(regex, "")
          .replace(regex1, "");
        let tempBranchAdd2 = "";
        if (fieldValues["branchAddress2" + i]) {
          tempBranchAdd2 = sanitizeHtml(
            fieldValues["branchAddress2" + i].trim(),
          )
            .replace(regex, "")
            .replace(regex1, "");
        }
        let tempBranchZip = sanitizeHtml(fieldValues["branchZip" + i].trim())
          .replace(regex, "")
          .replace(regex1, "");
        let tempBranchName = sanitizeHtml(fieldValues["branchName" + i].trim())
          .replace(regex, "")
          .replace(regex1, "");
        let tempBranchDesc = sanitizeHtml(
          fieldValues["branchDescription" + i].trim(),
        )
          .replace(regex, "")
          .replace(regex1, "");
        let tempBranchWebsiteURL = sanitizeHtml(
          fieldValues["branchWebsiteURL" + i].trim(),
        )
          .replace(regex, "")
          .replace(regex1, "");

        if (
          tempBranchAdd1 === "" ||
          tempBranchZip === "" ||
          tempBranchName === "" ||
          tempBranchDesc === "" ||
          tempBranchWebsiteURL === ""
        ) {
          message.error(
            "Invalid data. Please put valid data in the form fields.",
          );
          setSubmitBtnLoading(false);
          return false;
        }

        const clientDataPayload = {
          id: orgIdState.profileId,
          locationId: orgIdState.locationId,
          address1: tempBranchAdd1,
          address2: tempBranchAdd2,
          countryId:
            typeof fieldValues["branchCountryId" + i] == "string"
              ? orgIdState.countryId
              : fieldValues["branchCountryId" + i],
          cityId:
            typeof fieldValues["branchCityId" + i] == "string"
              ? orgIdState.cityId
              : fieldValues["branchCityId" + i],
          stateId:
            typeof fieldValues["branchStateId" + i] == "string"
              ? orgIdState.stateId
              : fieldValues["branchStateId" + i],
          zip: tempBranchZip,
          name: tempBranchName,
          description: tempBranchDesc,
          primaryHexColor: colorState.primaryHexColor,
          primaryFontDetails: fieldValues["branchPrimaryFontDetails" + i],
          secondaryHexColor: colorState.secondaryHexColor,
          secondaryFontDetails: fieldValues["branchSecondaryFontDetails" + i],
          layoutBackgroundColor: colorState.layoutBackgroundColor,
          logoBigUrl: bigLogoImagePath
            ? bigLogoImagePath
            : fieldValues["branchLogoBigUrl" + i],
          logoSmallUrl: smallLogoImagePath
            ? smallLogoImagePath
            : fieldValues["branchLogoSmallUrl" + i],
          faviconUrl: faviconImagePath
            ? faviconImagePath
            : fieldValues["branchFaviconUrl" + i],
          // effectiveStartDatetime: fieldValues["branchDateRange" + i]
          //   ? moment(fieldValues["branchDateRange0"][0].format('YYYY-MM-DD')).valueOf()
          //   : null,
          // effectiveEndDatetime: fieldValues["branchDateRange" + i]
          //   ? moment(fieldValues["branchDateRange0"][1].format('YYYY-MM-DD')).valueOf()
          //   : null,
          createdDttm: new Date().getTime(),
          updatedDttm: new Date().getTime(),
          websiteUrl: tempBranchWebsiteURL,
        };

        clientProfileData.push(clientDataPayload);
      }

      const requestBody = {
        client: {
          name: tempClientName,
          orgId: orgIdState.orgId,
          createdDttm: new Date().getTime(),
          updatedDttm: new Date().getTime(),
        },
        clientProfile: clientProfileData,
        clientUser: {
          email: tempClientEmail,
          id: orgIdState.clientEmailId,
        },
      };

      const response = await clientsApi.updateClient(id, requestBody);

      if (response) {
        const index = 0;
        const editedClient = {
          id: orgIdState.profileId,
          clientId: orgIdState.profileId,
          locationId: orgIdState.locationId,
          isDeleted: 0,
          clientName: tempClientName,
          description: sanitizeHtml(
            fieldValues["branchDescription" + index].trim(),
          )
            .replace(regex, "")
            .replace(regex1, ""),
          layoutBackgroundColor: colorState.layoutBackgroundColor,
          logoBigUrl: bigLogoImagePath
            ? bigLogoImagePath
            : fieldValues["branchLogoBigUrl" + index],
          logoSmallUrl: smallLogoImagePath
            ? smallLogoImagePath
            : fieldValues["branchLogoSmallUrl" + index],
          faviconUrl: faviconImagePath
            ? faviconImagePath
            : fieldValues["branchFaviconUrl" + index],
          name: sanitizeHtml(fieldValues["branchName" + index].trim())
            .replace(regex, "")
            .replace(regex1, ""),
          primaryHexColor: colorState.primaryHexColor,
          primaryFontDetails: fieldValues["branchPrimaryFontDetails" + index],
          secondaryHexColor: colorState.secondaryHexColor,
          secondaryFontDetails:
            fieldValues["branchSecondaryFontDetails" + index],
          createdDttm: new Date().getTime(),
          updatedDttm: new Date().getTime(),
        };

        // Set update data into client list array
        await editClientList(editedClient);
        message.success("Client details has been updated successfully.");
        setSubmitBtnLoading(false);
        history.push("/clients/allClients");
      }
    } catch (error) {
      message.error(
        "Form submission failed. Please check the form for errors.",
      );
      setSubmitBtnLoading(false);
    }
  };

  // Check duplicate email
  const handleDuplicateEmail = async (value) => {
    try {
      if (value.length > 0 && id === undefined) {
        // sanitize all input data
        const tempValue = sanitizeHtml(value)
          .replace(regex, "")
          .replace(regex1, "");
        if (tempValue !== "") {
          if (emailFieldTimeOut) clearTimeout(emailFieldTimeOut);
          emailFieldTimeOut = setTimeout(async () => {
            if (tempValue.includes("@") && tempValue.includes(".")) {
              const response =
                await clientsApi.handleDuplicateClientEmail(tempValue);
              const data = response ? response.data : "";
              if (data.count > 0) {
                setIsEmailExist({
                  isEmailEnterd: true,
                  isEmailExist: true,
                });
              } else {
                setIsEmailExist({
                  isEmailEnterd: false,
                  isEmailExist: false,
                });
              }
              return data;
            }
          }, 1000);
        } else {
          message.error("Invalid data. Please put valid data in the fields.");
        }
      } else {
        setIsEmailExist({
          isEmailEnterd: false,
          isEmailExist: false,
        });
      }
    } catch (e) {}
  };

  function getBase64(img, callback) {
    if (img) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    }
  }

  // image select then call this function
  const handleImageUpload = (fileList, fileCat) => {
    if (
      fileList.file.originFileObj &&
      (fileList.file.originFileObj.type === "image/png" ||
        fileList.file.originFileObj.type === "image/jpeg" ||
        fileList.file.originFileObj.type === "image/jpg")
    ) {
      let tempAssetImage = fileList.file;
      if (fileCat === "biglogo") {
        setBigLogoImage(tempAssetImage);
      } else if (fileCat === "smalllogo") {
        setSmallLogoImage(tempAssetImage);
      } else if (fileCat === "faviconlogo") {
        setFaviconImage(tempAssetImage);
      }

      getBase64(fileList.file.originFileObj, (imageUrl) =>
        fileCat === "biglogo"
          ? setBigLogoImageURL(imageUrl)
          : fileCat === "smalllogo"
            ? setSmallLogoImageURL(imageUrl)
            : fileCat === "faviconlogo"
              ? setFaviconImageURL(imageUrl)
              : "",
      );
      // setValidateAssetImage(true);
    }
  };

  //Before Images Upload
  function beforeImageUpload(file) {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isJpgOrPng) {
      message.error("Nope! We don't accept that file format.");
    }

    return isJpgOrPng;
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Form
      form={form}
      name="client-add-form"
      className="clientForm"
      requiredMark={false}
      onFinish={orgIdState.orgId ? clientUpdateFormSubmit : clientAddFormSubmit}
      scrollToFirstError
    >
      <h2 style={{ textAlign: "left", paddingBottom: "10px" }}>
        {orgIdState.orgId ? "Update Client" : "Add Client"}
      </h2>

      <Card style={{ padding: 16 }}>
        <Row gutter={16} className="custom-row">
          <Col xs={24} sm={12}>
            <FormItem
              label={
                <span>
                  Client Name:{" "}
                  <span style={{ color: "red", margin: "0", padding: "0" }}>
                    *
                  </span>
                </span>
              }
              name="name"
              labelAlign="top"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: (
                    <span className="custom-error-message">
                      Please enter client name.
                    </span>
                  ),
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter client name" />
            </FormItem>
          </Col>

          <Col xs={24} sm={12}>
            <FormItem
              label={
                <span>
                  Client Email:{" "}
                  <span style={{ color: "red", margin: "0", padding: "0" }}>
                    *
                  </span>
                </span>
              }
              name="email"
              labelAlign="top"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  type: "email",
                  message: (
                    <span className="custom-error-message">
                      Please enter valid email address.
                    </span>
                  ),
                },
                {
                  required: true,
                  whitespace: true,
                  message: (
                    <span className="custom-error-message">
                      Please enter email address.
                    </span>
                  ),
                },
                () => ({
                  validator(rule, value) {
                    return new Promise((resolve, reject) => {
                      handleDuplicateEmail(value).then((response) => {
                        if (response && response.count > 0) {
                          reject(
                            <span className="custom-error-message">
                              This email address already exists, please use a
                              different email address.
                            </span>,
                          );
                        } else {
                          resolve(value);
                        }
                      });
                    });
                  },
                }),
              ]}
            >
              <Input
                className="custom-input"
                placeholder="Enter client email"
                disabled={orgIdState.clientEmailId ? true : false}
              />
            </FormItem>
            {isEmailExist.isEmailEnterd && isEmailExist.isEmailExist && (
              <p className="custom-error-message">
                This email address already exists, please use a different email
                address.
              </p>
            )}
          </Col>
        </Row>
      </Card>

      <Card style={{ padding: 16 }}>
        <div className="branch-information">
          <h2>Branch Information</h2>
        </div>

        {clientProfile.map((address, index) => (
          <div key={index}>
            {clientProfile.length > 1 && <hr />}

            <Row gutter={16} className="custom-row">
              <Col xs={24} sm={12}>
                <FormItem
                  label={
                    <span>
                      Branch Name:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchName${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: (
                        <span className="custom-error-message">
                          Please enter branch name.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    style={{ width: "100%" }}
                    placeholder="Enter branch name"
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={12}>
                <FormItem
                  label={
                    <span>
                      Website URL:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchWebsiteURL${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: (
                        <span className="custom-error-message">
                          Please enter website URL.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    style={{ width: "100%" }}
                    placeholder="Enter website URL"
                  />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row">
              <Col xs={24} sm={12}>
                <FormItem
                  label={
                    <span>
                      Address 1:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchAddress1${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: (
                        <span className="custom-error-message">
                          Please enter address line 1.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    placeholder="Enter address 1"
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={12}>
                <FormItem
                  label={<span>Address 2:</span>}
                  name={`branchAddress2${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    className="custom-input"
                    placeholder="Enter address 2"
                  />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row">
              <Col xs={24} sm={6}>
                <FormItem
                  label={
                    <span>
                      Country:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchCountryId${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please select country.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="custom-input"
                    placeholder={"Select country"}
                    defaultActiveFirstOption={false}
                    dropdownStyle={{ textAlign: "left" }}
                    filterOption={false}
                    onSearch={setSearchCountry}
                    onChange={(value) =>
                      handleChange(index, "countryId", value)
                    }
                    notFoundContent={null}
                    options={(countryOptions || []).map((country) => ({
                      value: country.id,
                      label: country.name,
                    }))}
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={6}>
                <FormItem
                  label={
                    <span>
                      State:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchStateId${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please select state.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="custom-input"
                    placeholder="Select state"
                    defaultActiveFirstOption={false}
                    dropdownStyle={{ textAlign: "left" }}
                    filterOption={false}
                    onSearch={setSearchState}
                    onChange={(value) => handleChange(index, "stateId", value)}
                    notFoundContent={null}
                    options={(stateOptions || []).map((state) => ({
                      value: state.id,
                      label: state.name,
                    }))}
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={6}>
                <FormItem
                  label={
                    <span>
                      City:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchCityId${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please select city.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className="custom-input"
                    placeholder="Select city"
                    defaultActiveFirstOption={false}
                    dropdownStyle={{ textAlign: "left" }}
                    filterOption={false}
                    onSearch={setSearchCity}
                    onChange={(value) => handleChange(index, "cityId", value)}
                    notFoundContent={null}
                    options={(cityOptions || []).map((city) => ({
                      value: city.id,
                      label: city.name,
                    }))}
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={6}>
                <FormItem
                  label={
                    <span>
                      Zipcode:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchZip${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: (
                        <span className="custom-error-message">
                          Please enter zipcode.
                        </span>
                      ),
                    },
                    {
                      pattern: new RegExp("^[0-9]"),
                      message: (
                        <span className="custom-error-message">
                          Please enter valid zipcode.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Input className="custom-input" placeholder="Enter zipcode" />
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row">
              <Col xs={24} sm={12} key={index}>
                <FormItem
                  label={
                    <span>
                      Description:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchDescription${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: (
                        <span className="custom-error-message">
                          Please enter description.
                        </span>
                      ),
                    },
                  ]}
                >
                  <TextArea
                    className="custom-input"
                    placeholder="Enter description"
                    autoSize={{ minRows: 6, maxRows: 6 }}
                  />
                </FormItem>
              </Col>

              <Col xs={24} sm={12}>
                <Row gutter={16} className="custom-row">
                  <Col xs={24}>
                    <FormItem
                      label={
                        <span>
                          Primary Font Details:{" "}
                          <span
                            style={{ color: "red", margin: "0", padding: "0" }}
                          >
                            *
                          </span>
                        </span>
                      }
                      name={`branchPrimaryFontDetails${index}`}
                      labelCol={{ span: 24 }}
                      style={{
                        marginBottom: "16px",
                      }}
                      wrapperCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span className="custom-error-message">
                              Please enter primary font details.
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        className="custom-input"
                        placeholder="Select primary font details"
                        optionFilterProp="children"
                      >
                        <Option value="roboto">Roboto</Option>
                        <Option value="poppins">Poppins</Option>
                        <Option value="lato">Lato</Option>
                        <Option value="ubuntu">Ubuntu</Option>
                        <Option value="open-sans">Open Sans</Option>
                        <Option value="nunito-sans">Nunito Sans</Option>
                      </Select>
                    </FormItem>
                  </Col>

                  <Col xs={24}>
                    <FormItem
                      label={
                        <span>
                          Secondary Font Details:{" "}
                          <span
                            style={{ color: "red", margin: "0", padding: "0" }}
                          >
                            *
                          </span>
                        </span>
                      }
                      name={`branchSecondaryFontDetails${index}`}
                      labelCol={{ span: 24 }}
                      style={{ marginBottom: "16px" }}
                      wrapperCol={{ span: 24 }}
                      rules={[
                        {
                          required: true,
                          message: (
                            <span className="custom-error-message">
                              Please enter secondary font details.
                            </span>
                          ),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        className="custom-input"
                        placeholder="Select secondary font details"
                        optionFilterProp="children"
                      >
                        <Option value="roboto">Roboto</Option>
                        <Option value="poppins">Poppins</Option>
                        <Option value="lato">Lato</Option>
                        <Option value="ubuntu">Ubuntu</Option>
                        <Option value="open-sans">Open Sans</Option>
                        <Option value="nunito-sans">Nunito Sans</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row color-picker-row">
              <Col xs={24} sm={8}>
                <FormItem
                  label={
                    <span>
                      Primary Color:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`primaryHexColor${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: !address.primaryHexColor,
                      message: (
                        <span className="custom-error-message">
                          Please select primary hex color.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Popover
                    content={
                      <ColorPicker
                        color={colorState.primaryHexColor}
                        onChange={(value) => {
                          handleChange(index, "primaryHexColor", value);
                        }}
                      />
                    }
                    trigger="click"
                    title="Select Primary Hex Color"
                  >
                    <Button
                      type="default"
                      className="custom-button choose-color"
                    >
                      Choose Color
                    </Button>
                  </Popover>
                  <div
                    style={{
                      backgroundColor: colorState.primaryHexColor,
                      width: "30px",
                      height: "30px",
                      borderRadius: "6px",
                    }}
                  ></div>
                </FormItem>
              </Col>

              <Col xs={24} sm={8}>
                <FormItem
                  label={
                    <span>
                      Secondary Color:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`secondaryHexColor${index}`}
                  className="form-label"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please select secondary hex color.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Popover
                    content={
                      <ColorPicker
                        color={colorState?.secondaryHexColor}
                        onChange={(value) => {
                          handleChange(index, "secondaryHexColor", value);
                        }}
                      />
                    }
                    trigger="click"
                    title="Select Secondary Hex Color"
                  >
                    <Button
                      type="default"
                      className="custom-button choose-color"
                    >
                      Choose Color
                    </Button>
                  </Popover>
                  <div
                    style={{
                      backgroundColor: colorState.secondaryHexColor,
                      width: "30px",
                      height: "30px",
                      borderRadius: "6px",
                    }}
                  ></div>
                </FormItem>
              </Col>

              <Col xs={24} sm={8}>
                <FormItem
                  label={
                    <span>
                      Layout Background Color:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`layoutBackgroundColor${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please select layout background color.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Popover
                    content={
                      <ColorPicker
                        color={colorState.layoutBackgroundColor}
                        onChange={(value) => {
                          handleChange(index, "layoutBackgroundColor", value);
                        }}
                      />
                    }
                    trigger="click"
                    title="Select Layout Background Color"
                  >
                    <Button
                      type="default"
                      className="custom-button choose-color"
                    >
                      Choose Color
                    </Button>
                  </Popover>
                  <div
                    style={{
                      backgroundColor: colorState?.layoutBackgroundColor,
                      width: "30px",
                      height: "30px",
                      borderRadius: "6px",
                    }}
                  ></div>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row">
              <Col xs={24} sm={8}>
                <FormItem
                  label={
                    <span>
                      Big Logo:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchLogoBigUrl${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please upload big logo.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Upload
                    listType="picture-card"
                    className="upload-picture upload-logo-image"
                    showUploadList={false}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    onChange={(e) => handleImageUpload(e, "biglogo")}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    {bigLogoImageURL ? (
                      <img src={bigLogoImageURL} alt="avatar" />
                    ) : (
                      <Button>
                        <AiOutlineUpload />
                      </Button>
                    )}
                  </Upload>
                </FormItem>
                {bigLogoImageURL && (
                  <Upload
                    listType="picture-card"
                    className="upload-picture-button"
                    showUploadList={false}
                    onChange={(e) => handleImageUpload(e, "biglogo")}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    Change Image
                  </Upload>
                )}
                <span className="input-note">
                  Note: Accepted file types: png, jpg.
                </span>
              </Col>

              <Col xs={24} sm={8}>
                <FormItem
                  className="custom-form-item"
                  label={
                    <span>
                      Small Logo:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchLogoSmallUrl${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please upload small logo.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Upload
                    listType="picture-card"
                    className="upload-picture upload-logo-image"
                    showUploadList={false}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    onChange={(e) => handleImageUpload(e, "smalllogo")}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    {smallLogoImageURL ? (
                      <img src={smallLogoImageURL} alt="avatar" />
                    ) : (
                      <Button>
                        <AiOutlineUpload />
                      </Button>
                    )}
                  </Upload>
                </FormItem>
                {smallLogoImageURL && (
                  <Upload
                    listType="picture-card"
                    className="upload-picture-button"
                    showUploadList={false}
                    onChange={(e) => handleImageUpload(e, "smalllogo")}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    Change Image
                  </Upload>
                )}
                <span className="input-note">
                  Note: Accepted file types: png, jpg.
                </span>
              </Col>

              <Col xs={24} sm={8}>
                <FormItem
                  className="custom-form-item"
                  label={
                    <span>
                      Favicon:{" "}
                      <span style={{ color: "red", margin: "0", padding: "0" }}>
                        *
                      </span>
                    </span>
                  }
                  name={`branchFaviconUrl${index}`}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: (
                        <span className="custom-error-message">
                          Please upload favicon.
                        </span>
                      ),
                    },
                  ]}
                >
                  <Upload
                    listType="picture-card"
                    className="upload-picture upload-logo-image"
                    showUploadList={false}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    onChange={(e) => handleImageUpload(e, "faviconlogo")}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    {faviconImageURL ? (
                      <img src={faviconImageURL} alt="avatar" />
                    ) : (
                      <Button>
                        <AiOutlineUpload />
                      </Button>
                    )}
                  </Upload>
                </FormItem>
                {faviconImageURL && (
                  <Upload
                    listType="picture-card"
                    className="upload-picture-button"
                    showUploadList={false}
                    onChange={(e) => handleImageUpload(e, "faviconlogo")}
                    beforeUpload={beforeImageUpload}
                    customRequest={dummyRequest}
                    accept="image/png, image/jpeg, image/jpg"
                  >
                    Change Image
                  </Upload>
                )}
                <span className="input-note">
                  Note: Accepted file types: png, jpg.
                  <br />
                  Min resolution will be: 64px * 64px
                </span>
              </Col>
            </Row>

            <Row gutter={16} className="custom-row">
              {/* <Col xs={24} sm={12}>
                <FormItem
                  className="custom-form-item"
                  label={
                    <span >
                      Effective Date Range: <span style={{ color: "red", margin: '0', padding: '0' }}>*</span>
                    </span>
                  }
                  name={`branchDateRange${index}`} labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: <span className="custom-error-message">Please select dates.</span>,
                    },
                  ]}
                >
                  <RangePicker
                    className="custom-input-date"
                    format={dateFormat}
                    style={{ width: '100%' }}
                  />
                </FormItem>
              </Col> */}

              <Col
                xs={24}
                sm={12}
                style={{ textAlign: "right", verticalAlign: "bottom" }}
              >
                {clientProfile.length > 1 && (
                  <Button
                    className="ant-btn-danger ant-btn-background-ghost"
                    style={{ fontSize: "14px" }}
                    type="default"
                    onClick={() => removeClientProfile(index)}
                    icon={<MinusCircleOutlined style={{ fontSize: "17px" }} />}
                  >
                    Remove Client Profile
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        ))}
      </Card>

      <Row gutter={16} className="custom-row">
        <Col xs={24} style={{ textAlign: "right" }}>
          <Button type="link" onClick={() => handleCancel()}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitBtnLoading}
            disabled={isEmailExist.isEmailEnterd && isEmailExist.isEmailExist}
          >
            {orgIdState.orgId ? "Update" : "Save"}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ClientForm;
